import styled from 'styled-components';
import Modal from '~~elements/Modal';
import Select from '~~elements/Select';
import toast from '~~elements/Toast';
import Button from '~~elements/Button';
import { SeasonRegistryResource } from '~~apis/resource';
import RMultilingual from '../Multilingual';
import TeamSection from '../../../UserTournamentRegistry/TeamInRegistry/components/TeamSection';
import StaffsSection from '../../../UserTournamentRegistry/TeamInRegistry/components/StaffsSection';
import PlayersSection from '../../../UserTournamentRegistry/TeamInRegistry/components/PlayersSection';
import { useRegistryState } from '../useRegistry';
import { statusList } from './ReviewSection';
import { useState } from 'react';
import { useEffect } from 'react';
import { filter } from 'ramda';

const StyledDiv = styled.div`
  .title {
    font-size: 1.2rem;
    padding: 0.5rem 0;
    margin: 0.5rem 0 0.25rem 0;
    border-bottom: 1px solid gray;
  }
`;

const FooterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .wording {
    font-size: 1.1rem;
    margin-right: 0.5rem;
    font-weight: 600;
  }
`;

const ReviewTeamModal = ({ team, toClose, reload }) => {
  const { registryInfo } = useRegistryState();

  const [acceptedStatus, setAcceptedStatus] = useState([]);
  const [updateStatus, setUpdateStatus] = useState('SIGNED_UP');
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    setUpdateStatus(team.status);
  }, [team]);

  useEffect(() => {
    setAcceptedStatus(statusList);
    if (registryInfo.fee !== 0) {
      return;
    }

    setAcceptedStatus(filter((s) => !['REVIEW_COMPLETED', 'PAYMENT_CHECK_REQUESTED'].includes(s), statusList));
  }, [registryInfo]);

  const confirmUpdateStatus = () => {
    setUpdating(true);
    SeasonRegistryResource.updateReviewTeamStatus({
      seasonRegistryUniqid: registryInfo.uniqid,
      reviewTeamUniqid: team.uniqid,
      data: {
        status: updateStatus,
      },
    })
      .then(() => {
        reload(updateStatus);
        toast(RMultilingual(`SUCCESS.UPDATE`), { status: 'success', second: 1 });
      })
      .catch((e) => {
        toast(RMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error', second: 1 });
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  return (
    <Modal.Modal size="full" isOpen={true} onClickBack={toClose}>
      <Modal.ModalHeader hasBack={true} onClickBack={toClose}>
        {`${team.city} ${team.name}`}
      </Modal.ModalHeader>
      <Modal.ModalBody>
        <StyledDiv>
          <h3 className="title">{RMultilingual(`REVIEW.TEAM`)}</h3>
          <TeamSection
            teamInRegistry={team}
            registry={registryInfo}
            onChange={() => {}}
            apiInProgress={true}
            nonOrgMode={false}
          />
          <h3 className="title">{RMultilingual(`REVIEW.STAFF`)}</h3>
          <StaffsSection
            teamInRegistry={team}
            registry={registryInfo}
            onChange={() => {}}
            apiInProgress={true}
            nonOrgMode={false}
          />
          <h3 className="title">{RMultilingual(`REVIEW.PLAYER`)}</h3>
          <PlayersSection
            teamInRegistry={team}
            registry={registryInfo}
            onChange={() => {}}
            apiInProgress={true}
            nonOrgMode={false}
          />
        </StyledDiv>
      </Modal.ModalBody>
      <Modal.ModalFooter>
        <FooterDiv>
          <span className="wording">
            {`${RMultilingual(`TEAM_STATUS.WORDING`)}：`}
            {`${RMultilingual(`TEAM_STATUS.${team.status}`)}`}
            {`，${RMultilingual(`TEAM_STATUS.TO_UPDATE`)}`}
          </span>
          <Select width="unset" value={updateStatus} onChange={(e) => setUpdateStatus(e.target.value)}>
            {acceptedStatus.map((status) => (
              <option key={status} value={status}>
                {RMultilingual(`TEAM_STATUS.${status}`)}
              </option>
            ))}
          </Select>
          {team.status !== updateStatus && (
            <Button width="unset" color="red" onClick={confirmUpdateStatus} disabled={updating}>
              {RMultilingual(`COMMON.UPDATE`)}
            </Button>
          )}
        </FooterDiv>
      </Modal.ModalFooter>
    </Modal.Modal>
  );
};

export default ReviewTeamModal;
